import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { AppConstants } from '../../../utils/AppConstants';
import { AlertService } from '../../shared/alert/alert.service';
import { Locality } from '../../../models/Locality';
import { LocalityService } from '../../../services/locality.service';
import { CityAutocompleteComponent } from '../../shared/city-autocomplete/city-autocomplete.component';

@Component({
  selector: 'app-locality-detail',
  standalone: true,
  imports: [
    CommonModule,
    HasPermissionDirective,
    ConfirmAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    CityAutocompleteComponent,
  ],
  templateUrl: './locality-detail.component.html',
  styleUrl: './locality-detail.component.scss',
})
export class LocalityDetailComponent implements OnInit, OnDestroy {
  paramSubscription!: Subscription;
  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';

  id?: number;
  locality: Locality = {};
  detail_title: string = 'Nuova località';

  constructor(
    private localityService: LocalityService,
    private alertService: AlertService,
    private fullSpinnerService: FullSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.paramSubscription = this.activatedRoute.params.subscribe((parameter) => {
      this.id = parameter['id'];
      if (this.id! > 0) {
        this.fullSpinnerService.spinner('');
        this.localityService.get(this.id!).subscribe({
          next: (res) => {
            this.locality = res;
            this.detail_title = res.cityName ?? '';
          },
          complete: () => {
            this.fullSpinnerService.spinner(undefined);
          },
          error: () => {
            this.fullSpinnerService.spinner(undefined);
          },
        });
      }
    });
  }

  onSubmit(form: NgForm): void {
    if (!this.locality.cityId) {
      this.alertService.addErrors(
        AppConstants.titleErrorMessage,
        ["Seleziona una città dall'elenco."],
        true
      );
      return;
    }
    if (form.valid) {
      this.fullSpinnerService.spinner('');
      this.localityService.save(this.locality).subscribe({
        next: () => {
          this.alertService.addErrors(
            AppConstants.titleSuccessMessage,
            [AppConstants.successMessage],
            true
          );
          this.back();
        },
        complete: () => {
          this.fullSpinnerService.spinner(undefined);
        },
        error: () => {
          this.alertService.addErrors(
            AppConstants.titleErrorMessage,
            [AppConstants.errorMessage],
            true
          );
          this.fullSpinnerService.spinner(undefined);
        },
      });
    }
  }

  back(): void {
    this.router.navigate(['organization-config'], {
      queryParams: { tab: 'localities' },
    });
  }

  confirmDelete(): void {
    this.showConfirmationModal = true;
    this.confirmationMessage =
      'Sicuro di voler eliminare la località ' + (this.locality.cityName ?? '') + ' ?';
  }

  cancelDelete(): void {
    this.showConfirmationModal = false;
  }

  delete(): void {
    this.showConfirmationModal = false;
    this.fullSpinnerService.spinner('');
    this.localityService.delete(this.locality.id!).subscribe({
      next: () => {
        this.alertService.addErrors(
          AppConstants.titleDeleteSuccessMessage,
          [AppConstants.successMessage],
          true
        );
        this.back();
      },
      complete: () => {
        this.fullSpinnerService.spinner(undefined);
      },
      error: () => {
        this.alertService.addErrors(
          AppConstants.titleErrorMessage,
          [AppConstants.errorMessage],
          true
        );
        this.fullSpinnerService.spinner(undefined);
      },
    });
  }

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }
}
